import { inject, Injectable } from '@angular/core';

import { Router } from '@angular/router';
import { User } from '@base/@main/@pages/user-management/types/user.type';
import { ApiService } from '@shared/@services/api/api.service';
import { ApiResult } from '@shared/@types/api/api-result.type';
import { ForgetPasswordDTO } from '../forget-password/types/forget-password-dto.type';
import { ForgetPasswordResponse } from '../forget-password/types/forget-password-response.type';
import { LoginDTO, LoginResponse } from '../login/types/login-dto.type';
import { ResetPasswordDto } from '../reset-password/types/reset-password-dto.type';
import { ResetPasswordResponse } from '../reset-password/types/reset-password-response.type';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly apiService = inject(ApiService);
  currentUser: Partial<User> | null = null;
  private _router = inject(Router);
  fetched: boolean = false;

  private _url = 'auth';

  // secretKey = '';

  login(loginDTO: LoginDTO) {
    return this.apiService.post<ApiResult<LoginResponse>>(
      `${this._url}/login`,
      {
        ...loginDTO,
      },
    );
  }

  forgetPassword(forgetDTO: ForgetPasswordDTO) {
    return this.apiService.post<ApiResult<ForgetPasswordResponse>>(
      `${this._url}/forget-password`,
      {
        ...forgetDTO,
      },
    );
  }

  resetPassword(resetDTO: ResetPasswordDto) {
    return this.apiService.post<ApiResult<ResetPasswordResponse>>(
      `${this._url}/reset-password`,
      {
        ...resetDTO,
      },
    );
  }

  changePassword(password: string, newPassword: string) {
    return this.apiService.put<ApiResult<{ success: boolean }>>(
      `${this._url}/change-password`,
      {
        password,
        newPassword,
      },
    );
  }

  getCurrentUser() {
    return this.apiService.get<ApiResult<User>>(this._url + '/me');
  }

  // encrypt(dataToEncrypt: string) {
  //   return CryptoJS.AES.encrypt(dataToEncrypt, this.secretKey).toString();
  // }

  // decrypt(str: string) {
  //   let data = CryptoJS.AES.decrypt(str, this.secretKey).toString(
  //     CryptoJS.enc.Utf8,
  //   );
  //   return data;
  // }

  public getToken(): string | null {
    return localStorage.getItem('companyAccesstoken');
  }

  kickOut() {
    localStorage.removeItem('token');
    localStorage.removeItem('userDetails');
    this._router.navigateByUrl('external/login');
    this.currentUser = null;
  }
}
